import { Toast } from "../../models/toast"

const apply = (state: any, type: string, success: string, toastList: Toast[] = []) => {
    const matches = /(.*)_(REQUEST|SUCCESS)/.exec(type)

    // not a *_REQUEST / *_SUCCESS actions, so we ignore them
    if (!matches) return state

    const [, requestName, requestState] = matches

    const value = requestState === 'SUCCESS' && success ? success : undefined
    const existingToastList = state.toastList || []
    toastList = toastList.map(toast => ({...toast, id: Math.random() * 100}))
    const newToastList = [...existingToastList, ...toastList]

    return {
        ...state,
        [requestName]: value,
        __LAST: value,
        toastList: newToastList
    }
}

export default (state = {toastList: []}, action: any) => {
    const { type, success, toastList } = action
    switch (type) {
        case '__ALL_SUCCESS__':
            return {}
        case 'CLEAR_TOAST':
            const newToastList = [...state.toastList].filter(toast => action.toastIds.indexOf(toast.id) < 0)
            return {
                ...state,
                toastList: newToastList
            }
        default: {
            if (Array.isArray(type)) {
                const nextState = type.reduce((nState, t) => {
                    return apply(nState, t, success, toastList)
                }, state)
                return nextState
            } else {
                return apply(state, type, success, toastList)
            }
        }
    }
}
